var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "showData" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.totalItems) +
            "件 資金: " +
            _vm._s(_vm.totalCapital) +
            "円 優待総額: " +
            _vm._s(_vm.totalIncentiveValue) +
            "円 総費用: " +
            _vm._s(_vm.totalCost) +
            "円 売却利益: " +
            _vm._s(_vm.totalProfit) +
            "円\n    "
        ),
      ]),
      _vm._v(" "),
      _c("v-data-table", {
        ref: "refTable",
        staticClass: "elevation-1",
        attrs: {
          dense: "",
          headers: _vm.headers,
          items: _vm.UserIncentives,
          search: _vm.search,
          "items-per-page": 50,
          "footer-props": {
            "items-per-page-options": [10, 20, 50, 100, 200, 300, 400, 500],
            showFirstLastPage: true,
          },
          "multi-sort": "",
        },
        on: { "current-items": _vm.currentItems },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function () {
              return [
                _c(
                  "v-toolbar",
                  { attrs: { flat: "", color: "gray" } },
                  [
                    _c("v-toolbar-title", [_vm._v("優待取得状況一覧")]),
                    _vm._v(" "),
                    _c("v-divider", {
                      staticClass: "mx-3",
                      attrs: { inset: "", vertical: "" },
                    }),
                    _vm._v(" "),
                    _c(
                      "v-icon",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.refresh()
                          },
                        },
                      },
                      [_vm._v("refresh")]
                    ),
                    _vm._v(" "),
                    _c("v-spacer"),
                    _vm._v(" "),
                    _c("v-text-field", {
                      attrs: {
                        "append-icon": "search",
                        label: "銘柄名検索",
                        "single-line": "",
                        "hide-details": "",
                      },
                      model: {
                        value: _vm.nameFilterValue,
                        callback: function ($$v) {
                          _vm.nameFilterValue = $$v
                        },
                        expression: "nameFilterValue",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      attrs: {
                        "append-icon": "search",
                        label: "日付検索",
                        "single-line": "",
                        "hide-details": "",
                      },
                      model: {
                        value: _vm.dateFilterValue,
                        callback: function ($$v) {
                          _vm.dateFilterValue = $$v
                        },
                        expression: "dateFilterValue",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      attrs: {
                        "append-icon": "search",
                        label: "名義検索",
                        "single-line": "",
                        "hide-details": "",
                      },
                      model: {
                        value: _vm.holderFilterValue,
                        callback: function ($$v) {
                          _vm.holderFilterValue = $$v
                        },
                        expression: "holderFilterValue",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      attrs: {
                        "append-icon": "search",
                        label: "優待検索",
                        "single-line": "",
                        "hide-details": "",
                      },
                      model: {
                        value: _vm.incentiveFilterValue,
                        callback: function ($$v) {
                          _vm.incentiveFilterValue = $$v
                        },
                        expression: "incentiveFilterValue",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mb-2",
                        attrs: { fab: "", dark: "", small: "", color: "dark" },
                        on: {
                          click: function ($event) {
                            _vm.dialog = true
                          },
                        },
                      },
                      [_c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-dialog",
                      {
                        attrs: { "max-width": "700px" },
                        model: {
                          value: _vm.dialog,
                          callback: function ($$v) {
                            _vm.dialog = $$v
                          },
                          expression: "dialog",
                        },
                      },
                      [
                        _c(
                          "v-card",
                          [
                            _c("v-card-title", [
                              _c("span", { staticClass: "headline" }, [
                                _vm._v(_vm._s(_vm.formTitle)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-container",
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("StockCodeAutocomplete", {
                                              on: {
                                                updateStockName:
                                                  _vm.updateStockName,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: { label: "コード" },
                                              model: {
                                                value: _vm.editedItem.code,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "code",
                                                    $$v
                                                  )
                                                },
                                                expression: "editedItem.code",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c(
                                              "v-menu",
                                              {
                                                attrs: {
                                                  "max-width": "290px",
                                                  "min-width": "290px",
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "v-text-field",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                slot: "activator",
                                                                label:
                                                                  "権利取得日",
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.updateStockPrice,
                                                              },
                                                              slot: "activator",
                                                              model: {
                                                                value:
                                                                  _vm.editedItem
                                                                    .right_allotment_date,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.editedItem,
                                                                      "right_allotment_date",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "editedItem.right_allotment_date",
                                                              },
                                                            },
                                                            on
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                                model: {
                                                  value: _vm.menu,
                                                  callback: function ($$v) {
                                                    _vm.menu = $$v
                                                  },
                                                  expression: "menu",
                                                },
                                              },
                                              [
                                                _vm._v(" "),
                                                _c("v-date-picker", {
                                                  attrs: {
                                                    scrollable: true,
                                                    noTitle: true,
                                                    locale: "jp-ja",
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.updateStockPrice,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editedItem
                                                        .right_allotment_date,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editedItem,
                                                        "right_allotment_date",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editedItem.right_allotment_date",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "権利取得日株価",
                                              },
                                              model: {
                                                value:
                                                  _vm.editedItem
                                                    .right_allotment_price,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "right_allotment_price",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.right_allotment_price",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "権利落ち日株価",
                                              },
                                              model: {
                                                value:
                                                  _vm.editedItem
                                                    .right_loss_price,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "right_loss_price",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.right_loss_price",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: { label: "取得数" },
                                              model: {
                                                value:
                                                  _vm.editedItem.allotment_num,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "allotment_num",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.allotment_num",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: { label: "優待品" },
                                              model: {
                                                value: _vm.editedItem.incentive,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "incentive",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.incentive",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: { label: "優待価値" },
                                              model: {
                                                value:
                                                  _vm.editedItem
                                                    .incentive_value,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "incentive_value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.incentive_value",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: { label: "名義" },
                                              model: {
                                                value:
                                                  _vm.editedItem.holder_name,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "holder_name",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.holder_name",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: { label: "株主番号" },
                                              model: {
                                                value:
                                                  _vm.editedItem.holder_number,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "holder_number",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.holder_number",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                label: "会社",
                                                items: _vm.Companies,
                                                "item-text": "name",
                                                "item-value": "id",
                                                required: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.editedItem.company_id,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "company_id",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.company_id",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "2" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: { label: "買手数料" },
                                              model: {
                                                value:
                                                  _vm.editedItem
                                                    .transaction_fee,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "transaction_fee",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.transaction_fee",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "2" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: { label: "金利" },
                                              model: {
                                                value:
                                                  _vm.editedItem.interest_buy,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "interest_buy",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.interest_buy",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "2" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: { label: "売手数料" },
                                              model: {
                                                value:
                                                  _vm.editedItem
                                                    .transaction_fee_sell,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "transaction_fee_sell",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.transaction_fee_sell",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "2" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: { label: "金利" },
                                              model: {
                                                value:
                                                  _vm.editedItem.interest_sell,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "interest_sell",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.interest_sell",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "2" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: { label: "逆日歩" },
                                              model: {
                                                value:
                                                  _vm.editedItem.backwordation,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "backwordation",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.backwordation",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "2" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: { label: "配当金" },
                                              model: {
                                                value: _vm.editedItem.dividend,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "dividend",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.dividend",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                label: "取引区分",
                                                items: _vm.TransactionTypes,
                                                "item-text": "text",
                                                "item-value": "value",
                                                required: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.editedItem
                                                    .transaction_type,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "transaction_type",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.transaction_type",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                label: "長期優待有無",
                                                items: _vm.Answer,
                                                "item-text": "text",
                                                "item-value": "value",
                                                required: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.editedItem
                                                    .is_long_term_incentive,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "is_long_term_incentive",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.is_long_term_incentive",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                label: "端株取得有無",
                                                items: _vm.Answer,
                                                "item-text": "text",
                                                "item-value": "value",
                                                required: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.editedItem
                                                    .is_odd_lot_holding,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "is_odd_lot_holding",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.is_odd_lot_holding",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c(
                                              "v-menu",
                                              {
                                                attrs: {
                                                  "max-width": "290px",
                                                  "min-width": "290px",
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "v-text-field",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                slot: "activator",
                                                                label:
                                                                  "優待受取日",
                                                              },
                                                              slot: "activator",
                                                              model: {
                                                                value:
                                                                  _vm.editedItem
                                                                    .incentive_recieve_date,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.editedItem,
                                                                      "incentive_recieve_date",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "editedItem.incentive_recieve_date",
                                                              },
                                                            },
                                                            on
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                                model: {
                                                  value: _vm.menu2,
                                                  callback: function ($$v) {
                                                    _vm.menu2 = $$v
                                                  },
                                                  expression: "menu2",
                                                },
                                              },
                                              [
                                                _vm._v(" "),
                                                _c("v-date-picker", {
                                                  attrs: {
                                                    scrollable: true,
                                                    noTitle: true,
                                                    locale: "jp-ja",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editedItem
                                                        .incentive_recieve_date,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editedItem,
                                                        "incentive_recieve_date",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editedItem.incentive_recieve_date",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c(
                                              "v-menu",
                                              {
                                                attrs: {
                                                  "max-width": "290px",
                                                  "min-width": "290px",
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "v-text-field",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                slot: "activator",
                                                                label:
                                                                  "優待有効期限",
                                                              },
                                                              slot: "activator",
                                                              model: {
                                                                value:
                                                                  _vm.editedItem
                                                                    .expiration_date,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.editedItem,
                                                                      "expiration_date",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "editedItem.expiration_date",
                                                              },
                                                            },
                                                            on
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                                model: {
                                                  value: _vm.menu3,
                                                  callback: function ($$v) {
                                                    _vm.menu3 = $$v
                                                  },
                                                  expression: "menu3",
                                                },
                                              },
                                              [
                                                _vm._v(" "),
                                                _c("v-date-picker", {
                                                  attrs: {
                                                    scrollable: true,
                                                    noTitle: true,
                                                    locale: "jp-ja",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editedItem
                                                        .expiration_date,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editedItem,
                                                        "expiration_date",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editedItem.expiration_date",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: { label: "優待残額" },
                                              model: {
                                                value: _vm.editedItem.remain,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "remain",
                                                    $$v
                                                  )
                                                },
                                                expression: "editedItem.remain",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: { label: "売却利益" },
                                              model: {
                                                value:
                                                  _vm.editedItem.auction_profit,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "auction_profit",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.auction_profit",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-card-actions",
                              [
                                _c("v-spacer"),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "blue darken-1", text: "" },
                                    on: { click: _vm.close },
                                  },
                                  [_vm._v("Cancel")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "blue darken-1", text: "" },
                                    on: { click: _vm.save },
                                  },
                                  [_vm._v("Save")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "item.actions",
            fn: function ({ item }) {
              return [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.editItem(item)
                      },
                    },
                  },
                  [_vm._v("\n                mdi-pencil\n            ")]
                ),
                _vm._v(" "),
                _c(
                  "v-icon",
                  {
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.deleteItem(item)
                      },
                    },
                  },
                  [_vm._v("\n                mdi-delete\n            ")]
                ),
              ]
            },
          },
          {
            key: "item.profitability",
            fn: function ({ item }) {
              return [
                _c(
                  "v-chip",
                  {
                    attrs: {
                      color: _vm.getColor(item.profitability),
                      dark: "",
                    },
                  },
                  [_vm._v(_vm._s(item.profitability))]
                ),
              ]
            },
          },
          {
            key: "item.used",
            fn: function ({ item }) {
              return [
                _c(
                  "v-chip",
                  { attrs: { color: _vm.getColor(item.used), dark: "" } },
                  [_vm._v(_vm._s(item.used))]
                ),
              ]
            },
          },
          {
            key: "item.name",
            fn: function ({ item }) {
              return [
                _vm._v("\n            " + _vm._s(item.name)),
                _c("br"),
                _c("ExternalLinks", { attrs: { code: item.code } }),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snacktxt) + "\n    ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }